<template>
  <div class="content">
    <h2 class="heading">{{ getContent(currentLocaleData, defaultLocaleData, 'title') }}</h2>

    <div v-if="questionsList.length" class="items">
      <expander
        v-for="(item, itemIndex) in questionsList"
        :key="itemIndex"
        :title="item.question"
        :content="item.answer"
        class="item"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IQuestionCategory } from '~/types';
  const { getContent } = useProjectMethods();

  const route = useRoute();
  const { pageIdentity } = route.params;

  const contentParams = {
    contentKey: `${pageIdentity}-question`,
    contentRoute: ['question-pages', `${pageIdentity}`],
  };
  const { getContentData } = useContentLogic<IQuestionCategory>(contentParams);
  const { data: categoryContent } = await useLazyAsyncData(getContentData);

  const currentLocaleData = computed(() => categoryContent?.value?.currentLocaleData);
  const defaultLocaleData = computed(() => categoryContent?.value?.defaultLocaleData);

  const questionsList = computed(() => {
    return getContent(currentLocaleData.value, defaultLocaleData.value, 'questionList', []);
  });
</script>
